import React, {useState, useEffect, useRef} from 'react';
import Spinner from '../spinners/spinner';

const ViewState = {
  initial: 'initial',
  actionInProgress: 'action-in-progress',
  actionCompleted: 'action-completed',
};

const ActionResult = {
  aborted: 'aborted',
};
export {ActionResult};

const ActionButton = ({action, errorHandler, className, disabled, children}) => {

  const mountedRef = useRef(false);

  const [viewState, setViewState] = useState(ViewState.initial);
  const [_disabled, setDisabled] = useState(!!disabled);

  useEffect(() => setDisabled(!!disabled), [disabled]);
  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false };
  }, []);

  const onClick = async () => {
    setViewState(ViewState.actionInProgress);
    try {
      let actionResult = action();
      const asyncAction = !!((actionResult || {}).then);
      if (asyncAction) {
        actionResult = await actionResult;
      }
      if (mountedRef.current) {
        if (!asyncAction || actionResult === ActionResult.aborted) {
          setInitialViewState();
        } else {
          setViewState(ViewState.actionCompleted);
          setTimeout(() => setInitialViewState(), 2000);
        }
      }
    } catch (err) {
      setInitialViewState();
      if (errorHandler) {
        errorHandler(err);
      } else {
        window.alert(err.stack || JSON.stringify(err));
      }
    }
  };

  const setInitialViewState = () => {
    if (mountedRef.current) {
      setViewState(ViewState.initial);
    }
  };

  const buildFullClassName = () => {
    let result = 'btn';
    if (className) {
      result += ' ' + className;
    }
    return result;
  };

  const content = () => {
    if (viewState === ViewState.actionInProgress) {
      return <Spinner sizeInPx={14}/>;
    } else if (viewState === ViewState.actionCompleted) {
      return <span className="align-middle material-icons"
                   style={{color: '#5cb85c', transition: 'opacity .5s ease-in-out'}}>&#xE5CA;</span>;
    } else {
      return children;
    }
  }

  return <button type="button"
                 className={buildFullClassName()}
                 onClick={() => onClick()}
                 disabled={_disabled || viewState === ViewState.actionInProgress}>
    {content()}
  </button>;
};

export default ActionButton;
